import { get } from 'lodash/fp';

export const getExperiment = get(['experiment']);
